import * as yup from "yup";

const PosData = {
    intialValues : {
        name:"",
        company_address:"",
        website:"",
        email:"",
        point_of_contact  :"",
        countrycode:91,   
        environment:"STAGING", 
        pos_config_id:"",
        staging_config: {
            app_key: "",
            app_secret: "",
            access_token: "",
            api_key: "",
            base_url: "",
            password: "",
          },
          production_config: {
            app_key: "",
            app_secret: "",
            access_token: "",
            api_key: "",
            base_url: "",
            password: "",
          },
          runningStatus:"0",
    },
    validationSchema : yup.object({
        name:yup.string().required("name is required").max(50,"Max 50 characters"),
        pos_config_id:yup.string().required("select pos"),
        company_address:yup.string().required("company Address is required"),
        website:yup.string().required("Website is required"),
        email: yup.string().required("Email is required").email("Invalid email format"),
        point_of_contact: yup
          .string()
          .required("Point of Contact is required")
          .matches(/^\d{10}$/, "Invalid phone number format (10 digits)"),

    })
}

export default PosData;